import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { spacing } from 'ui/theme';
import { Dispatch, SetStateAction } from 'react';
import { BaseSendEditorProps } from '../BaseSendEditor.types';
import SectionTitle from '../SectionTitle';
import { TemplatePreview, TemplatePreviewProps } from './TemplatePreview';

export const StyledWarningBanner = styled(WarningBanner)`
  margin-bottom: ${spacing.threeQuarter};
`;
export interface ContentSectionProps extends TemplatePreviewProps {
  /** The title shown in section header */
  title?: string;
  banner?: BaseSendEditorProps['contentBanner'];
  isDisabled?: boolean;
  showSnippetErrorsWarning?: boolean;
  showTemplateErrorsWarning?: boolean;
  currentLocale?: string;
  setCurrentLocale: Dispatch<SetStateAction<string | undefined>>;
}

export const ContentSection = ({
  title = 'Content',
  banner,
  showTemplateErrorsWarning = false,
  showSnippetErrorsWarning = false,
  ...props
}: ContentSectionProps) => {
  return (
    <>
      <SectionTitle title={title} banner={banner} />
      {showTemplateErrorsWarning && (
        <StyledWarningBanner title="Needs review">
          Please update this campaign to resolve errors.
        </StyledWarningBanner>
      )}
      {showSnippetErrorsWarning && (
        <StyledWarningBanner title="Missing snippets">
          Please update this campaign to reference snippets in this project.
        </StyledWarningBanner>
      )}

      <TemplatePreview {...props} />
    </>
  );
};

export default ContentSection;
